module.exports = __webpack_public_path__ + "static/media/national-rehabilitation-hospital.aa252dcb.png";